import { TimelineMax, Power3 } from 'gsap';

const TheOthersIn = (element) => {
  const chars = [...element.querySelectorAll('.the-others__title-char')];
  const text = element.querySelector('.the-others__text');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(chars, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start')
    .to(text, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+0.6');
  return tl;
};

export default TheOthersIn;
